import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import GenericList, { GenericListItem } from '../../../components/GenericList';
import IconButton from '../../../components/IconButton';
import Link from '../../../components/Link';
import Popover from '../../../components/Popover';
import { ModalManagementStore } from '../../../providers/modal-manager';

export type LinkData = {
  linkHeader: string;
  route: string;
  icon?: any;
  disableRightIcon?: boolean;
  rightIcon?: any;
  modal?: boolean;
  target?: string;
  params?: any;
};

export type PopoverWithLinksProps = React.PropsWithChildren<{
  linksData: LinkData[];
  header?: string;
}>;

const PopoverWithLinks = ({ linksData, header }: PopoverWithLinksProps) => {
  const navigate = useNavigate();
  const { openModal } = useContext(ModalManagementStore);
  const popOverWithLinksBody = (
    <Container className={'px-0 popover-with-links'}>
      <GenericList>
        {linksData.map((linkData, index) => {
          return (
            <GenericListItem key={index} withoutBorder={false}>
              <Link
                className={'py-0'}
                leftIcon={linkData.icon || null}
                rightIcon={
                  !linkData.disableRightIcon
                    ? linkData.rightIcon || light('chevron-right')
                    : null
                }
                onClick={() => {
                  if (linkData.modal) {
                    document.body.click();
                    openModal(linkData.route, linkData.params);
                  } else if (linkData.target === '_blank') {
                    window.open(linkData.route);
                  } else {
                    navigate(linkData.route);
                  }
                }}
                isAlignAtEnd
              >
                {linkData.linkHeader}
              </Link>
            </GenericListItem>
          );
        })}
      </GenericList>
    </Container>
  );

  return (
    <Popover
      trigger="click"
      placement="bottom-end"
      popoverBody={popOverWithLinksBody}
    >
      <IconButton extLabel={header} variant="icon-default" icon={light('ellipsis')} />
    </Popover>
  );
};

export default PopoverWithLinks;
